<template>
  <div class="vld-parent">
    <Loading
      :active.sync="$store.state.isLoading"
      color="black"
      background-color="white" />
  </div>
</template>

<script>

// https://github.com/ankurk91/vue-loading-overlay
import Loading from 'vue-loading-overlay'

export default {
  components: {
    Loading
  },
  data: () => ({
  }),
  props: {
    isLoading: Boolean
  }
}
</script>

<style>
  .vld-shown {
    overflow: hidden;
  }
  .vld-overlay {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    display: none;
    justify-content: center;
    overflow: hidden;
    z-index: 9999;
  }
  .vld-overlay.is-active {
    display: flex;
    background-color: #fff;
    opacity: 0.3;
  }
  .vld-overlay.is-full-page {
    z-index: 9999;
    position: fixed;
  }
  .vld-overlay .vld-background {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background: #fff;
    opacity: 0.5;
  }
  .vld-overlay .vld-icon, .vld-parent {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Loading.vue